import { NgModule, Component, ChangeDetectionStrategy, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import {TooltipModule} from "primeng/tooltip";

@Component({
  selector: 'my-avatar',
  template: `
        <div [ngClass]="containerClass()" [class]="styleClass" [ngStyle]="style">
            <ng-content></ng-content>
            <span class="p-avatar-text" *ngIf="label; else iconTemplate">{{ label }}</span>
            <ng-template #iconTemplate><span [class]="icon" [ngClass]="'p-avatar-icon'" *ngIf="icon; else imageTemplate"></span></ng-template>
            <ng-template #imageTemplate><img [src]="image" *ngIf="image" (error)="imageError($event)"  pTooltip="{{tooltipText}}"/></ng-template>
        </div>
    `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./my_avatar.css'],
  host: {
    class: 'p-element'
  }
})
export class MyAvatar {
  @Input() label: string;
  
  @Input() icon: string;
  
  @Input() image: string;
  
  @Input() size: string = 'normal';
  
  @Input() shape: string = 'square';
  
  @Input() style: any;
  
  @Input() styleClass: string;
  
  @Input()
  tooltipText: string;
  
  @Output() onImageError: EventEmitter<any> = new EventEmitter();
  
  containerClass() {
    return {
      'p-avatar p-component': true,
      'p-avatar-image': this.image != null,
      'p-avatar-circle': this.shape === 'circle',
      'p-avatar-lg': this.size === 'large',
      'p-avatar-xl': this.size === 'xlarge'
    };
  }
  
  imageError(event) {
    this.onImageError.emit(event);
  }
}

@NgModule({
  imports: [CommonModule, TooltipModule],
  exports: [MyAvatar],
  declarations: [MyAvatar]
})
export class MyAvatarModule {}
